"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "dunningLetter",
    path: "/dunning-letters/:id",
    component: "DunningLetter"
});
let DunningLetter = class DunningLetter extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    id;
    onId(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("id");
    }
    payload;
    onPayload(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("payload");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.payload || (this.id !== null
            ? this.$fn.fetch('read_dunning_letter', { asResource: true, parameters: { id: this.id } })
            : this.$fn.schemaDefaults('DunningLetter'));
    }
    templates;
    async $$load_templates() {
        return this.$fn.fetch('list_template');
    }
    emailTemplates;
    async $$load_emailTemplates() {
        return _.filter(this.templates, {
            object_type: 'dunning_letter',
            template_type: 'mjml'
        });
    }
    htmlTemplates;
    async $$load_htmlTemplates() {
        return _.filter(this.templates, {
            object_type: 'dunning_letter',
            template_type: 'html'
        });
    }
    sendmail;
    async $$load_sendmail() {
        return {
            email: _.isArray(this.item.customer_data.emails)
                ? _.join(this.item.customer_data.emails, '; ')
                : this.item.customer_data.emails,
            template: _.get(_.first(this.emailTemplates), 'id')
        };
    }
    printdoc;
    async $$load_printdoc() {
        return { template: _.get(_.first(this.htmlTemplates), 'id') };
    }
    ux;
    b_7315092382398562_modalBindings;
    b_7495010493811270_style;
    b_6865942025371558_style;
    b_3273883411533724_options;
    b_2771751501651205_columns;
    dataMembers = ['item', 'templates', 'emailTemplates', 'htmlTemplates', 'sendmail', 'printdoc', 'ux', 'b_7315092382398562_modalBindings', 'b_7495010493811270_style', 'b_6865942025371558_style', 'b_3273883411533724_options', 'b_2771751501651205_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                templates: null,
                emailTemplates: null,
                htmlTemplates: null,
                sendmail: null,
                printdoc: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "xl",
                },
                b_7495010493811270_style: {
                    minWidth: "250px",
                },
                b_6865942025371558_style: {
                    minWidth: "250px",
                },
                b_3273883411533724_options: [{
                        value: null,
                        text: "-",
                    },
                    {
                        value: "sent",
                        text: this.$fn.pgettext("DunningLetterStatus", "Sent"),
                    },
                    {
                        value: "delivered",
                        text: this.$fn.pgettext("DunningLetterStatus", "Delivered"),
                    },
                    {
                        value: "error",
                        text: this.$fn.pgettext("DunningLetterStatus", "Error"),
                    },
                ],
                b_2771751501651205_columns: [{
                        name: this.$fn.gettext("Invoice number"),
                        field: "invoice_number",
                    },
                    {
                        name: this.$fn.gettext("Completion date"),
                        field: "invoice_data.fulfillment_date",
                        textAlign: "right",
                        type: "date",
                    },
                    {
                        name: this.$fn.gettext("Due date"),
                        field: "invoice_data.due_date",
                        textAlign: "right",
                        type: "date",
                    },
                    {
                        name: this.$fn.gettext("Amount"),
                        field: "invoice_data.amount",
                        textAlign: "right",
                        type: "number",
                    },
                    {
                        name: this.$fn.gettext("Paid"),
                        field: "invoice_data.paid",
                        textAlign: "right",
                        type: "number",
                    },
                    {
                        name: this.$fn.gettext("Debt"),
                        field: "invoice_data.debt",
                        textAlign: "right",
                        type: "number",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: ([this.item.snapshot('reference_number') || this.$fn.gettext('Dunning Letter')]),
                icon: this.$config.dunningLetter.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7598_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_3943151158818434_clickPreventStop(event, scope) {
        return await this.actions.evh_3943151158818434_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8518026866742051_closeComponent_7606_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async act_8518026866742051_reloadSlickgrid_7608_getActionArgs($event) {
        return {
            grid: "all",
        };
    }
    async act_8518026866742051_request_7604_getActionArgs($event) {
        return {
            operation: "delete_dunning_letter",
            data: this.item,
        };
    }
    async act_8518026866742051_request_7604_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_8518026866742051_clickPreventStop(event, scope) {
        return await this.actions.evh_8518026866742051_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2492577004902623_script_7610_getActionArgs_value($event) {
        this.$refs.sendMailDropdown.hide(true);
    }
    async act_2492577004902623_script_7610_getActionArgs($event) {
        return {
            value: () => this.act_2492577004902623_script_7610_getActionArgs_value($event),
        };
    }
    async act_2492577004902623_reloadSlickgrid_7614_getActionArgs($event) {
        return {
            grid: "all",
        };
    }
    async evh_2492577004902623_completed(event, scope) {
        return await this.actions.evh_2492577004902623_completed.executeFromDOM(this, event, scope);
    }
    async act_4810867692521497_script_7616_getActionArgs_value($event) {
        this.$refs.generatePdfDropdown.hide(true);
    }
    async act_4810867692521497_script_7616_getActionArgs($event) {
        return {
            value: () => this.act_4810867692521497_script_7616_getActionArgs_value($event),
        };
    }
    async act_4810867692521497_reloadSlickgrid_7620_getActionArgs($event) {
        return {
            grid: "all",
        };
    }
    async evh_4810867692521497_completed(event, scope) {
        return await this.actions.evh_4810867692521497_completed.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_setData_7624_getActionArgs($event) {
        return {
            path: "item",
            value: new this.$fn.Resource($event.data.response.data),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_7789867021953041_success_7623_getWhen($event) {
        return !!$event.data.response.data;
    }
    async act_7789867021953041_form_7626_getActionArgs($event) {
        return {
            name: "dunningLetter",
            reset: true,
        };
    }
    async act_7789867021953041_reloadSlickgrid_7628_getActionArgs($event) {
        return {
            grid: "all",
        };
    }
    async act_7789867021953041_request_7622_getActionArgs($event) {
        return {
            operation: "update_dunning_letter",
            data: this.item,
        };
    }
    async evh_7789867021953041_submit(event, scope) {
        return await this.actions.evh_7789867021953041_submit.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7598 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7598_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7597 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7598,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7597],
        });
        const act_2248226175642056_closeComponent_7600 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_7599 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_7600,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_7599],
        });
        const act_3943151158818434_reloadComponentData_7602 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reloadData",
            events: [],
        });
        const evh_3943151158818434_clickPreventStop_7601 = new core_1.actions.EventHandlerImpl({
            action: act_3943151158818434_reloadComponentData_7602,
            event: "click.prevent.stop",
            displayName: "reloadData",
        });
        const evh_3943151158818434_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3943151158818434_clickPreventStop_7601],
        });
        const act_8518026866742051_closeComponent_7606 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_8518026866742051_closeComponent_7606_getActionArgs,
            events: [],
        });
        const evh_8518026866742051_success_7605 = new core_1.actions.EventHandlerImpl({
            action: act_8518026866742051_closeComponent_7606,
            event: "success",
            displayName: "closeComponent",
        });
        const act_8518026866742051_reloadSlickgrid_7608 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8518026866742051_reloadSlickgrid_7608_getActionArgs,
            events: [],
        });
        const evh_8518026866742051_success_7607 = new core_1.actions.EventHandlerImpl({
            action: act_8518026866742051_reloadSlickgrid_7608,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_8518026866742051_request_7604 = new core_1.actions.RequestAction({
            actionArgs: this.act_8518026866742051_request_7604_getActionArgs,
            confirm: this.act_8518026866742051_request_7604_getConfirm,
            displayName: "delete",
            events: [evh_8518026866742051_success_7605, evh_8518026866742051_success_7607],
        });
        const evh_8518026866742051_clickPreventStop_7603 = new core_1.actions.EventHandlerImpl({
            action: act_8518026866742051_request_7604,
            event: "click.prevent.stop",
            displayName: "delete",
        });
        const evh_8518026866742051_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8518026866742051_clickPreventStop_7603],
        });
        const act_2492577004902623_script_7610 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2492577004902623_script_7610_getActionArgs,
            events: [],
        });
        const evh_2492577004902623_completed_7609 = new core_1.actions.EventHandlerImpl({
            action: act_2492577004902623_script_7610,
            event: "completed",
            displayName: "script",
        });
        const act_2492577004902623_reloadComponentData_7612 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2492577004902623_completed_7611 = new core_1.actions.EventHandlerImpl({
            action: act_2492577004902623_reloadComponentData_7612,
            event: "completed",
            displayName: "reloadComponentData",
        });
        const act_2492577004902623_reloadSlickgrid_7614 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2492577004902623_reloadSlickgrid_7614_getActionArgs,
            events: [],
        });
        const evh_2492577004902623_completed_7613 = new core_1.actions.EventHandlerImpl({
            action: act_2492577004902623_reloadSlickgrid_7614,
            event: "completed",
            displayName: "reloadSlickgrid",
        });
        const evh_2492577004902623_completed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2492577004902623_completed_7609, evh_2492577004902623_completed_7611, evh_2492577004902623_completed_7613],
        });
        const act_4810867692521497_script_7616 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4810867692521497_script_7616_getActionArgs,
            events: [],
        });
        const evh_4810867692521497_completed_7615 = new core_1.actions.EventHandlerImpl({
            action: act_4810867692521497_script_7616,
            event: "completed",
            displayName: "script",
        });
        const act_4810867692521497_reloadComponentData_7618 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_4810867692521497_completed_7617 = new core_1.actions.EventHandlerImpl({
            action: act_4810867692521497_reloadComponentData_7618,
            event: "completed",
            displayName: "reloadComponentData",
        });
        const act_4810867692521497_reloadSlickgrid_7620 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_4810867692521497_reloadSlickgrid_7620_getActionArgs,
            events: [],
        });
        const evh_4810867692521497_completed_7619 = new core_1.actions.EventHandlerImpl({
            action: act_4810867692521497_reloadSlickgrid_7620,
            event: "completed",
            displayName: "reloadSlickgrid",
        });
        const evh_4810867692521497_completed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4810867692521497_completed_7615, evh_4810867692521497_completed_7617, evh_4810867692521497_completed_7619],
        });
        const act_7789867021953041_setData_7624 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7789867021953041_setData_7624_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_success_7623 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_setData_7624,
            event: "success",
            when: this.evh_7789867021953041_success_7623_getWhen,
            displayName: "setData",
        });
        const act_7789867021953041_form_7626 = new core_1.actions.FormAction({
            actionArgs: this.act_7789867021953041_form_7626_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_success_7625 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_form_7626,
            event: "success",
            displayName: "form",
        });
        const act_7789867021953041_reloadSlickgrid_7628 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_7789867021953041_reloadSlickgrid_7628_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_success_7627 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_reloadSlickgrid_7628,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_7789867021953041_request_7622 = new core_1.actions.RequestAction({
            actionArgs: this.act_7789867021953041_request_7622_getActionArgs,
            displayName: "save",
            events: [evh_7789867021953041_success_7623, evh_7789867021953041_success_7625, evh_7789867021953041_success_7627],
        });
        const evh_7789867021953041_submit_7621 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_request_7622,
            event: "submit",
            displayName: "save",
        });
        const evh_7789867021953041_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_submit_7621],
        });
        const act_1548630417156826_closeComponent_7630 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_7629 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_7630,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_7629],
        });
        return {
            act_7315092382398562_closeModal_7598,
            evh_7315092382398562_close_7597,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_7600,
            evh_2248226175642056_close_7599,
            evh_2248226175642056_close,
            act_3943151158818434_reloadComponentData_7602,
            evh_3943151158818434_clickPreventStop_7601,
            evh_3943151158818434_clickPreventStop,
            act_8518026866742051_closeComponent_7606,
            evh_8518026866742051_success_7605,
            act_8518026866742051_reloadSlickgrid_7608,
            evh_8518026866742051_success_7607,
            act_8518026866742051_request_7604,
            evh_8518026866742051_clickPreventStop_7603,
            evh_8518026866742051_clickPreventStop,
            act_2492577004902623_script_7610,
            evh_2492577004902623_completed_7609,
            act_2492577004902623_reloadComponentData_7612,
            evh_2492577004902623_completed_7611,
            act_2492577004902623_reloadSlickgrid_7614,
            evh_2492577004902623_completed_7613,
            evh_2492577004902623_completed,
            act_4810867692521497_script_7616,
            evh_4810867692521497_completed_7615,
            act_4810867692521497_reloadComponentData_7618,
            evh_4810867692521497_completed_7617,
            act_4810867692521497_reloadSlickgrid_7620,
            evh_4810867692521497_completed_7619,
            evh_4810867692521497_completed,
            act_7789867021953041_setData_7624,
            evh_7789867021953041_success_7623,
            act_7789867021953041_form_7626,
            evh_7789867021953041_success_7625,
            act_7789867021953041_reloadSlickgrid_7628,
            evh_7789867021953041_success_7627,
            act_7789867021953041_request_7622,
            evh_7789867021953041_submit_7621,
            evh_7789867021953041_submit,
            act_1548630417156826_closeComponent_7630,
            evh_1548630417156826_clickPreventStop_7629,
            evh_1548630417156826_clickPreventStop,
            reloadData: act_3943151158818434_reloadComponentData_7602,
            delete: act_8518026866742051_request_7604,
            save: act_7789867021953041_request_7622,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], DunningLetter.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DunningLetter.prototype, "onId", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], DunningLetter.prototype, "payload", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('payload'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DunningLetter.prototype, "onPayload", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "xl",
    }),
    __metadata("design:type", String)
], DunningLetter.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DunningLetter.prototype, "onSize", null);
DunningLetter = __decorate([
    (0, vue_property_decorator_1.Component)()
], DunningLetter);
exports.default = DunningLetter;
vue_property_decorator_1.Vue.component("DunningLetter", DunningLetter);
